import React, { useState } from 'react'

import {
  Button,
  Flex,
  InputText,
  Modal,
  RadioGroup,
  RadioItem,
  Tooltip,
  useToast,
} from '@driftt/dds'
import { tracking } from '@driftt/traffic-control'

import { surveryQuestions } from './FeedbackModal.constants'

interface FeedbackModalProps {
  open: boolean
  onClose: () => void
  onDismiss: () => void
}

export const SalesRepsFeedbackModal = ({
  open,
  onClose,
  onDismiss,
}: FeedbackModalProps) => {
  const triggerToast = useToast()

  const [surveryResponses, setSurveryResponses] = useState(surveryQuestions)
  const [radioButtonResponse, setRadioButtonResponse] = useState({
    question: 'How helpful is the new Sales Rep Setup report to you?',
    response: '',
  })

  const handleSubmit = () => {
    tracking.trackEvent('SALES_REPS_SETUP_FEEDBACK-2023', {
      feedback: [...surveryResponses, radioButtonResponse],
    })
    triggerToast({
      message: 'Feedback submitted',
      variant: 'success',
    })
    onClose()
    onDismiss()
  }

  const handleResponseChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const newSurveryResponses = [...surveryResponses]
    newSurveryResponses[index].response = e.target.value
    setSurveryResponses(newSurveryResponses)
  }

  const responsesEmpty = surveryQuestions
    .slice(0, 2)
    .every((question) => question.response !== '')

  const handleRadioButtonValueChange = (value: string) => {
    setRadioButtonResponse({ ...radioButtonResponse, response: value })
  }

  return (
    <Modal.Root open={open} onClose={onClose}>
      <Modal.Dialog size="large" variant="info" fullWidth>
        <Modal.Title title="Give feedback" />
        <Modal.Content as={Flex} gap={2} direction="column" fullWidth>
          <RadioGroup
            label="How helpful is the new Sales Rep Setup report to you?"
            value={radioButtonResponse.response}
            onValueChange={handleRadioButtonValueChange}
          >
            <RadioItem value="Very helpful" label="Very helpful" />
            <RadioItem value="Somewhat helpful" label="Somewhat helpful" />
            <RadioItem value="Not helpful" label="Not helpful" />
          </RadioGroup>
          {surveryResponses.map((question, index) => {
            return (
              <InputText
                key={index}
                size="full-width"
                label={question.question}
                value={question.response}
                onChange={(e) => handleResponseChange(e, index)}
              />
            )
          })}
        </Modal.Content>
        <Modal.Actions>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          {responsesEmpty ? (
            <Button
              variant="primary"
              disabled={!responsesEmpty}
              onClick={handleSubmit}
            >
              Submit
            </Button>
          ) : (
            <Tooltip
              content="Please complete required questions before submitting"
              side="top"
            >
              <Button
                variant="primary"
                disabled={!responsesEmpty}
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </Tooltip>
          )}
        </Modal.Actions>
      </Modal.Dialog>
    </Modal.Root>
  )
}
